/**
 * Field Value Preserver Controller
 *
 * Preserves date/time field values across part navigation.
 *
 * @package Ninja Forms Multi-Part
 * @since 1.x.x
 * @see Issue #207, #206, #225
 */
define( 'controllers/fieldValuePreserver',[], function() {
	var controller = Marionette.Object.extend( {

		/**
		 * Cache of field values indexed by field ID
		 */
		fieldCache: {},

		/**
		 * Cache of date-only field values (Issue #225)
		 */
		dateOnlyCache: {},

		initialize: function() {
			var self = this;

			// Listen for changes on time select elements
			jQuery( document ).on( 'change', '.hour, .minute, .ampm', function( e ) {
				self.onTimeSelectChange( e );
			} );

			// Also cache on initial page interaction (in case selects have default values)
			// Use mousedown to capture values BEFORE click handlers destroy the DOM
			jQuery( document ).on( 'mousedown', '.nf-next, .nf-previous', function( e ) {
				self.cacheAllVisibleTimeFields();
				self.cacheDateOnlyFields();  // Issue #225
			} );

			// Intercept form submission at the earliest point
			this.listenTo( nfRadio.channel( 'forms' ), 'before:submit', this.onBeforeSubmit );
		},

		/**
		 * Cache all currently visible time field values
		 */
		cacheAllVisibleTimeFields: function() {
			var self = this;

			jQuery( '.nf-field-container' ).each( function() {
				var $container = jQuery( this );
				var $hour = $container.find( '.hour' );

				if ( ! $hour.length ) return;

				var fieldId = $container.data( 'id' );
				if ( ! fieldId ) {
					var $input = $container.find( '.nf-element' ).first();
					if ( $input.length && $input.attr( 'id' ) ) {
						fieldId = $input.attr( 'id' ).replace( /^nf-field-/, '' );
					}
				}

				if ( ! fieldId ) return;

				var $minute = $container.find( '.minute' );
				var $ampm = $container.find( '.ampm' );

				// Also get the date value
				var $dateInput = $container.find( 'input[type="hidden"], input.nf-element' ).first();
				var dateValue = $dateInput.length ? $dateInput.val() : '';

				self.fieldCache[ fieldId ] = {
					date: dateValue,
					hour: $hour.val() || null,
					minute: $minute.val() || null,
					ampm: $ampm.val() || null
				};
			} );
		},

		/**
		 * Cache date-only field values from hidden inputs (Issue #225)
		 * This captures the formatted date before DOM is destroyed during part navigation
		 */
		cacheDateOnlyFields: function() {
			var self = this;

			jQuery( '.nf-field-container' ).each( function() {
				var $container = jQuery( this );

				// Find the hidden input with the formatted date value
				var $hiddenInput = $container.find( 'input[type="hidden"].datepicker' );
				if ( ! $hiddenInput.length ) {
					// Try alternate selector - any hidden input with datepicker-related class
					$hiddenInput = $container.find( 'input[type="hidden"].flatpickr-input' );
				}
				if ( ! $hiddenInput.length ) return; // Not a date field

				// Skip if this has time selects (not date_only)
				if ( $container.find( '.hour' ).length ) return;

				var fieldId = $container.data( 'id' );
				if ( ! fieldId ) {
					// Try to get ID from the input
					var inputId = $hiddenInput.attr( 'id' );
					if ( inputId ) {
						fieldId = inputId.replace( /^nf-field-/, '' );
					}
				}

				if ( ! fieldId ) return;

				// Cache the formatted date value from the hidden input
				var formattedDate = $hiddenInput.val();
				if ( formattedDate ) {
					self.dateOnlyCache[ String( fieldId ) ] = formattedDate;
				}
			} );
		},

		/**
		 * Called when any time select changes
		 */
		onTimeSelectChange: function( e ) {
			var $select = jQuery( e.target );
			var $container = $select.closest( '.nf-field-container' );

			if ( ! $container.length ) return;

			var fieldId = $container.data( 'id' );
			if ( ! fieldId ) {
				var $input = $container.find( '.nf-element' ).first();
				if ( $input.length && $input.attr( 'id' ) ) {
					fieldId = $input.attr( 'id' ).replace( /^nf-field-/, '' );
				}
			}

			if ( ! fieldId ) return;

			var $hour = $container.find( '.hour' );
			var $minute = $container.find( '.minute' );
			var $ampm = $container.find( '.ampm' );

			// Get date value
			var $dateInput = $container.find( 'input[type="hidden"], input.nf-element' ).first();
			var dateValue = $dateInput.length ? $dateInput.val() : '';

			this.fieldCache[ fieldId ] = {
				date: dateValue,
				hour: $hour.val() || null,
				minute: $minute.val() || null,
				ampm: $ampm.val() || null
			};
		},

		/**
		 * Before form submission - patch all date field models with cached values
		 */
		onBeforeSubmit: function( formModel ) {
			var self = this;
			var fields = formModel.get( 'fields' );

			if ( ! fields || ! fields.models ) return;

			fields.models.forEach( function( fieldModel ) {
				if ( 'date' !== fieldModel.get( 'type' ) ) return;

				var dateMode = fieldModel.get( 'date_mode' );
				var fieldId = fieldModel.get( 'id' );

				// Handle date_only fields (Issue #225)
				if ( 'date_only' === dateMode ) {
					var cachedDate = self.dateOnlyCache[ String( fieldId ) ];
					if ( cachedDate ) {
						// Use cached formatted date instead of Date object
						// Use silent:true to prevent triggering validation
						fieldModel.set( 'value', cachedDate, { silent: true } );
					}
					return;
				}

				var cached = self.fieldCache[ fieldId ];

				if ( ! cached ) return;

				// Check if field DOM is available
				var el = fieldModel.get( 'el' );
				var $el = jQuery( el );
				var domAvailable = $el.length && $el.find( '.hour' ).length && $el.closest( 'body' ).length;

				if ( domAvailable ) {
					// DOM exists, let normal processing handle it
					return;
				}

				// DOM is not available - we need to set the value directly
				// The beforeSubmit in fieldDate.js won't be able to read DOM
				// So we set the model value to what it should be

				if ( 'time_only' === dateMode ) {
					var timeValue = '';
					if ( cached.hour && cached.minute ) {
						timeValue = cached.hour + ':' + cached.minute;
						if ( cached.ampm ) {
							timeValue += ' ' + cached.ampm;
						}
					}
					fieldModel.set( 'value', timeValue );
				} else {
					// date_and_time - set as object that matches what beforeSubmit creates
					fieldModel.set( 'value', {
						date: cached.date || '',
						hour: cached.hour || '',
						minute: cached.minute || '',
						ampm: cached.ampm || ''
					} );
				}

				// Override getValue for this submission
				var originalGetValue = fieldModel.getValue;
				fieldModel.getValue = function() {
					var val = this.get( 'value' );

					if ( typeof val === 'object' && val !== null ) {
						var result = val.date || '';
						if ( val.hour && val.minute ) {
							result += ' ' + val.hour + ':' + val.minute;
						}
						if ( val.ampm ) {
							result += ' ' + val.ampm;
						}
						return result;
					}

					return val;
				};
			} );
		}

	} );

	return controller;
} );

